import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  z-index: ", ";\n\n  &[x-placement*='top'] ", " {\n    margin-bottom: 8px;\n  }\n\n  &[x-placement*='bottom'] ", " {\n    margin-top: 8px;\n  }\n\n  &[x-placement*='right'] ", " {\n    margin-left: 8px;\n  }\n\n  &[x-placement*='left'] ", " {\n    margin-right: 8px;\n  }\n\n  &[x-placement*='bottom'] ", " {\n    top: 4px;\n    left: 0;\n    margin-top: 0;\n    margin-left: 4px;\n    margin-right: 4px;\n\n    &::before {\n      content: '';\n      display: block;\n      width: 0;\n      height: 0;\n      margin: 0;\n      border-style: solid;\n      border-width: 0 4px 4px 4px;\n      border-color: transparent transparent currentcolor transparent;\n    }\n  }\n\n  &[x-placement*='top'] ", " {\n    bottom: 4px;\n    left: 0;\n    margin-bottom: 0;\n    margin-left: 4px;\n    margin-right: 4px;\n\n    &::before {\n      content: '';\n      display: block;\n      width: 0;\n      height: 0;\n      margin: 0;\n      border-style: solid;\n      border-width: 4px 4px 0 4px;\n      border-color: currentcolor transparent transparent transparent;\n    }\n  }\n\n  &[x-placement*='right'] ", " {\n    left: 4px;\n    margin-left: 0;\n    margin-top: 4px;\n    margin-bottom: 4px;\n\n    &::before {\n      content: '';\n      display: block;\n      width: 0;\n      height: 0;\n      margin: 0;\n      border-style: solid;\n      border-width: 4px 4px 4px 0;\n      border-color: transparent currentcolor transparent transparent;\n    }\n  }\n\n  &[x-placement*='left'] ", " {\n    right: 4px;\n    margin-right: 0;\n    margin-top: 4px;\n    margin-bottom: 4px;\n\n    &::before {\n      content: '';\n      display: block;\n      width: 0;\n      height: 0;\n      margin: 0;\n      border-style: solid;\n      border-width: 4px 0 4px 4px;\n      border-color: transparent transparent transparent currentcolor;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: -1;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1.54;\n  box-sizing: border-box;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef, useState, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { color, border, shadow } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { useDefaultRef } from '../utils/useDefaultRef';
import Popper from '../popper/Popper';
import { Box } from '../grid/Grid';
var Wrap = styled(Box)(_templateObject(), color, border, shadow);
var Arrow = styled.span(_templateObject2(), color);
var StyledPopper = styled(Popper)(_templateObject3(), themeGet('zIndex.tooltip'), Wrap, Wrap, Wrap, Wrap, Arrow, Arrow, Arrow, Arrow);
export var Tooltip =
/*#__PURE__*/
forwardRef(function Tooltip(props) {
  var _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      placement = props.placement,
      propOpen = props.open,
      children = props.children,
      rest = _objectWithoutProperties(props, ["title", "arrow", "placement", "open", "children"]);

  var _useDefaultRef = useDefaultRef(children.ref),
      _useDefaultRef2 = _slicedToArray(_useDefaultRef, 2),
      ownRef = _useDefaultRef2[0],
      setOwnRef = _useDefaultRef2[1];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      arrowRef = _useState2[0],
      setArrowRef = _useState2[1];

  var _useState3 = useState(propOpen),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var popperOptions = useMemo(function () {
    return {
      modifiers: {
        arrow: {
          enabled: arrow,
          element: arrowRef
        }
      }
    };
  }, [arrow, arrowRef]);
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.cloneElement(children, {
      ref: setOwnRef,
      onMouseOver: useCallback(function () {
        if (!open) {
          setOpen(true);
        }
      }, [setOpen, open]),
      onMouseLeave: useCallback(function () {
        if (open) {
          setOpen(false);
        }
      }, [setOpen, open])
    }),
    /*#__PURE__*/
    React.createElement(StyledPopper, {
      referRef: ownRef,
      open: open || propOpen || false,
      placement: placement,
      popperOptions: popperOptions
    },
    /*#__PURE__*/
    React.createElement(Wrap, _extends({
      px: "8px",
      py: "4px",
      color: "white",
      bg: "#464a52",
      borderRadius: "5px",
      maxWidth: "300px"
    }, rest), title, arrow &&
    /*#__PURE__*/
    React.createElement(Arrow, {
      color: rest.bg || rest.backgroundColor || 'black',
      ref: setArrowRef
    }))))
  );
});